<template>
  <p-create v-if="$hasPermission('templates')" type="visio" />
  <p-not-found v-else />
</template>

<script>
import Create from './../components/documents/visio/CreateDocument.vue';
import NotFound from './../components/NotFound.vue';
export default {
  components: {
    'p-not-found': NotFound,
    'p-create': Create
  }
};
</script>
